module.exports = __webpack_public_path__ + "img/empty.c8906ea8.png";